
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/sa/partners/[id]",
      function () {
        return require("private-next-pages/sa/partners/[id].jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/sa/partners/[id]"])
      });
    }
  